import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';
import { SaleStat } from './sale-stat';

@JsonObject('model.SalesGraph')
export class SalesGraph extends AbstractModel {

	@JsonProperty(String, 'startDate')
	startDate?: string;

	@JsonProperty(String, 'endDate')
	endDate?: string;

	@JsonProperty([SaleStat], 'childStats')
	childStats?: SaleStat[];

}
